/* FÉNIX R07 · MOLECULAR HOLOGRAM · LIVING LAYER v02 · product-neutral */
(()=>{
  const boot=()=>{
    const reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fine=window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));

    document.querySelectorAll('[data-fnx-hologram-master]').forEach(master=>{
      if(master.dataset.fnxLivingBooted==='1')return;
      master.dataset.fnxLivingBooted='1';
      master.classList.add('fnx-holo-living-js');

      const reveal=Array.from(master.querySelectorAll('.fnx-card,.fnx-topic,.fnx-grid>div,.fnx-q,.fnx-links a'));
      reveal.forEach((el,index)=>{
        el.classList.add('fnx-holo-reveal');
        el.style.setProperty('--fnx-reveal-delay',`${Math.min((index%6)*65,325)}ms`);
      });

      if(reduce||!('IntersectionObserver' in window)){
        reveal.forEach(el=>el.classList.add('is-visible'));
      }else{
        const io=new IntersectionObserver((entries,observer)=>{
          entries.forEach(entry=>{
            if(entry.isIntersecting){
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },{threshold:.12,rootMargin:'0px 0px -7% 0px'});
        reveal.forEach(el=>io.observe(el));
      }

      if(fine&&!reduce){
        master.querySelectorAll('.fnx-card').forEach(card=>{
          card.addEventListener('pointermove',e=>{
            const r=card.getBoundingClientRect();
            card.style.setProperty('--fnx-card-x',`${clamp((e.clientX-r.left)/Math.max(1,r.width),0,1)*100}%`);
            card.style.setProperty('--fnx-card-y',`${clamp((e.clientY-r.top)/Math.max(1,r.height),0,1)*100}%`);
          },{passive:true});
          card.addEventListener('pointerleave',()=>{
            card.style.setProperty('--fnx-card-x','50%');
            card.style.setProperty('--fnx-card-y','0%');
          },{passive:true});
        });
      }

      /* runtime-v03 is the sole timeline authority; living keeps reveal/card light only. */
      if(master.classList.contains('fnx-runtime-v03'))return;

      const timelines=Array.from(master.querySelectorAll('.fnx-tl'));
      if(!timelines.length)return;

      let ticking=false;
      const update=()=>{
        ticking=false;
        const trigger=window.innerHeight*.67;
        timelines.forEach(tl=>{
          const items=Array.from(tl.querySelectorAll(':scope > li'));
          if(!items.length)return;
          const tr=tl.getBoundingClientRect();
          let active=-1;
          items.forEach((item,index)=>{
            const r=item.getBoundingClientRect();
            const y=r.top+Math.min(20,r.height*.2);
            if(y<=trigger)active=index;
          });
          items.forEach((item,index)=>{
            item.classList.toggle('is-active',index===active);
            item.classList.toggle('is-past',index<active);
          });
          if(active<0){
            tl.style.setProperty('--fnx-tl-progress','0%');
            return;
          }
          const ar=items[active].getBoundingClientRect();
          const local=(ar.top+Math.min(20,ar.height*.2))-tr.top;
          tl.style.setProperty('--fnx-tl-progress',`${clamp(local/Math.max(1,tr.height)*100,0,100)}%`);
        });
      };
      const request=()=>{
        if(!ticking){
          ticking=true;
          requestAnimationFrame(update);
        }
      };
      window.addEventListener('scroll',request,{passive:true});
      window.addEventListener('resize',request,{passive:true});
      master.querySelectorAll('details').forEach(details=>details.addEventListener('toggle',request,{passive:true}));
      request();
    });
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
})();